export const CSS = {
  toggleIcon: "toggle-icon",
};
